import { TweenLite, Back } from 'gsap'

export const dropBackwards = element => TweenLite.to(element, 0.3, { z: '-=10', ease: Back.easeIn })

export const flyUpOffScreen = element => TweenLite.to(element, 0.2, { y: '-150%' })

export const reset = element => {
  TweenLite.set(element, { clearProps: 'y, z', opacity: 0 })
  TweenLite.to(element, 2, { opacity: 1, delay: 0.8 })
}
